// extracted by mini-css-extract-plugin
export var blue = "_15-f";
export var brand = "_15-b";
export var darkGrey = "_15-e";
export var disabled = "_15-4";
export var disabledSubtle = "_15-5";
export var error = "_15-6";
export var green = "_15-g";
export var grey = "_15-d";
export var icon = "_15-0";
export var inherit = "_15-a";
export var lightGrey = "_15-c";
export var orange = "_15-i";
export var pink = "_15-k";
export var primary = "_15-1";
export var purple = "_15-l";
export var red = "_15-j";
export var secondary = "_15-2";
export var success = "_15-9";
export var tertiary = "_15-3";
export var warning = "_15-7";
export var warningSecondary = "_15-8";
export var white = "_15-m";
export var yellow = "_15-h";